import { Catalog } from '../api/CataloguesAPI';

/** Public catalogues chosen as media-rich examples from different brands. */
export const ONBOARDING_EXAMPLE_CATALOGUE_UUIDS = [
  "da0a2f29-03b7-408b-892c-4300e112236d", // Mari Lill — Kolekcja City Lights 2025
  "da36f093-568f-4314-88fc-9eba318a248a", // Dama Couture
  "b9a885ec-5af2-4468-bfb3-bf2220a7e0cd", // Belik's
] as const;

export const exampleCatalogPillLabel = (
  catalog: Pick<Catalog, 'name' | 'designer' | 'storeName'>
): string => {
  const designer = catalog.designer?.trim() || '';
  const store = catalog.storeName?.trim() || '';
  const brand = designer && store && designer !== store
    ? `${designer} (${store})`
    : designer || store;
  if (brand && catalog.name) {
    return `${brand} — ${catalog.name}`;
  }
  return catalog.name || brand;
};
